
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mapa-do-site",
      function () {
        return require("private-next-pages/mapa-do-site/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mapa-do-site"])
      });
    }
  